import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import TransactionExport from 'transaction-export-lib';
import { RequiresAuthenticatedUser } from '../RequiresAuthenticatedUser';
import AppStore from '../../stores/AppStore';
import SessionStore from '../../stores/SessionStore';
import UserManagementStore from '../../stores/UserManagementStore';
import InternetBankingActions from '../../actions/InternetBankingActions';
import envConfig from '../../../static/config';
import StringConstants from '../../constants/StringConstants';
import AccountsStore from '../../stores/AccountsStore';
import ApiUtils from '../../utils/ApiUtils';
import { getBrandId } from '../../utils/BrandUtils';

class ExportTransactionLanding extends React.Component {
  constructor(props) {
    super(props);
    this.backToAccountDetails = this.backToAccountDetails.bind(this);
    this.getConfig = this.getConfig.bind(this);
    this.getAccountDetails = this.getAccountDetails.bind(this);
  }

  getAccountDetails() {
    const accountDetails = AccountsStore.getAccountDetail(
      AccountsStore.getAccount()
    );
    return {
      id: accountDetails.id,
      metadata: accountDetails.metadata,
      product: accountDetails.product,
      number: accountDetails.number,
      type: accountDetails.type,
    };
  }

  getConfig() {
    const accessToken =
      SessionStore.getURLTokenValue() ||
      SessionStore.getToken()['access_token'];
    return {
      ibApiUrl: `${envConfig.apiBaseUrlPAAS}/ibapi/v2`,
      clientContext: ApiUtils.getApiClientContext(),
      accessToken,
      userTrackingId: AppStore.getUserTrackingID(),
      brandId: getBrandId(),
      bankId: SessionStore.getSessionBankID(),
    };
  }

  backToAccountDetails() {
    InternetBankingActions.navigateToWebTask(
      StringConstants.WEB_ACCOUNT_DETAILS
    );
  }

  render() {
    return (
      <div id="page" className="bow page export-transaction-landing-page">
        <Helmet title={this.props.content.exportTransaction} />
        <div className="web-ui-components">
          <TransactionExport
            userSegment={UserManagementStore.getCADetails().segment}
            accountDetails={this.getAccountDetails()}
            config={this.getConfig()}
            onBack={this.backToAccountDetails}
          />
        </div>
      </div>
    );
  }
}

ExportTransactionLanding.propTypes = {
  content: PropTypes.object,
};

export default RequiresAuthenticatedUser(ExportTransactionLanding);
